// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-fetch';
import type { GetAirlinesData, GetAirlinesResponse, GetAirportsData, GetAirportsResponse, GetBusstationsData, GetBusstationsResponse, GetCabinCategoryTypesData, GetCabinCategoryTypesResponse, GetCabinsData, GetCabinsResponse, GetCssBaseDataData, GetCssBaseDataResponse, GetOfferData, GetOfferResponse, GetPortsData, GetPortsResponse, GetPortsByPortCodeData, GetPortsByPortCodeResponse, GetRegionsData, GetRegionsResponse, GetShipsData, GetShipsResponse, GetShipsByShipCodeData, GetShipsByShipCodeResponse, GetShipsByShipCodeCabinTypesAndCategoriesData, GetShipsByShipCodeCabinTypesAndCategoriesResponse, GetShipsByShipCodeDecksData, GetShipsByShipCodeDecksResponse, GetShipsByShipCodeVenueCategoriesData, GetShipsByShipCodeVenueCategoriesResponse, GetShipsByShipCodeVenueCategoriesByVenueCategoryCodeData, GetShipsByShipCodeVenueCategoriesByVenueCategoryCodeResponse, GetTripsData, GetTripsResponse, GetTripsByDateByDateData, GetTripsByDateByDateResponse, GetTripsInvalidateData, GetTripsInvalidateResponse, PostTripsInvalidateData, GetTripsByTripCodeCabinTypesAndCategoriesData, GetTripsByTripCodeCabinTypesAndCategoriesResponse, GetTripsByTripCodeCabinTypesAndCategoriesByCabinCategoryCodeData, GetTripsByTripCodeCabinTypesAndCategoriesByCabinCategoryCodeResponse, GetTripsByTripCodeCabinsData, GetTripsByTripCodeCabinsResponse, GetTripsByTripCodeCabinsByCabinNumberData, GetTripsByTripCodeCabinsByCabinNumberResponse, GetTripsByTripCodeChecklistData, GetTripsByTripCodeChecklistResponse, GetTripsByTripCodeEventsData, GetTripsByTripCodeEventsResponse, GetTripsByTripCodeThemeContentData, GetTripsByTripCodeThemeContentResponse, GetVenueByVenueCodeData, GetVenueByVenueCodeResponse, GetVenueCategoriesData, GetVenueCategoriesResponse, GetVenueCategoriesByVenueCategoryCodeData, GetVenueCategoriesByVenueCategoryCodeResponse } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Airlines
 */
export const getAirlines = <ThrowOnError extends boolean = false>(options?: Options<GetAirlinesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAirlinesResponse, unknown, ThrowOnError>({
        url: '/airlines',
        ...options
    });
};

/**
 * Get Airports
 */
export const getAirports = <ThrowOnError extends boolean = false>(options?: Options<GetAirportsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAirportsResponse, unknown, ThrowOnError>({
        url: '/airports',
        ...options
    });
};

/**
 * Get Busstations
 */
export const getBusstations = <ThrowOnError extends boolean = false>(options?: Options<GetBusstationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBusstationsResponse, unknown, ThrowOnError>({
        url: '/busstations',
        ...options
    });
};

/**
 * Get Cabin Information
 */
export const getCabinCategoryTypes = <ThrowOnError extends boolean = false>(options?: Options<GetCabinCategoryTypesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCabinCategoryTypesResponse, unknown, ThrowOnError>({
        url: '/cabinCategoryTypes',
        ...options
    });
};

/**
 * Get Cabins
 */
export const getCabins = <ThrowOnError extends boolean = false>(options?: Options<GetCabinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCabinsResponse, unknown, ThrowOnError>({
        url: '/cabins',
        ...options
    });
};

/**
 * Get Base Data
 */
export const getCssBaseData = <ThrowOnError extends boolean = false>(options?: Options<GetCssBaseDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCssBaseDataResponse, unknown, ThrowOnError>({
        url: '/css/baseData',
        ...options
    });
};

/**
 * Get Offer Data
 */
export const getOffer = <ThrowOnError extends boolean = false>(options?: Options<GetOfferData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOfferResponse, unknown, ThrowOnError>({
        url: '/offer',
        ...options
    });
};

/**
 * Get Ports
 */
export const getPorts = <ThrowOnError extends boolean = false>(options?: Options<GetPortsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPortsResponse, unknown, ThrowOnError>({
        url: '/ports',
        ...options
    });
};

/**
 * Get Port
 */
export const getPortsByPortCode = <ThrowOnError extends boolean = false>(options: Options<GetPortsByPortCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPortsByPortCodeResponse, unknown, ThrowOnError>({
        url: '/ports/{portCode}',
        ...options
    });
};

/**
 * Get Regions
 */
export const getRegions = <ThrowOnError extends boolean = false>(options?: Options<GetRegionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegionsResponse, unknown, ThrowOnError>({
        url: '/regions',
        ...options
    });
};

/**
 * Get Ships
 */
export const getShips = <ThrowOnError extends boolean = false>(options?: Options<GetShipsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetShipsResponse, unknown, ThrowOnError>({
        url: '/ships',
        ...options
    });
};

/**
 * Get Ship
 */
export const getShipsByShipCode = <ThrowOnError extends boolean = false>(options: Options<GetShipsByShipCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetShipsByShipCodeResponse, unknown, ThrowOnError>({
        url: '/ships/{shipCode}',
        ...options
    });
};

/**
 * Get Cabin Information
 */
export const getShipsByShipCodeCabinTypesAndCategories = <ThrowOnError extends boolean = false>(options: Options<GetShipsByShipCodeCabinTypesAndCategoriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetShipsByShipCodeCabinTypesAndCategoriesResponse, unknown, ThrowOnError>({
        url: '/ships/{shipCode}/cabinTypesAndCategories',
        ...options
    });
};

/**
 * Get Decks
 */
export const getShipsByShipCodeDecks = <ThrowOnError extends boolean = false>(options: Options<GetShipsByShipCodeDecksData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetShipsByShipCodeDecksResponse, unknown, ThrowOnError>({
        url: '/ships/{shipCode}/decks',
        ...options
    });
};

/**
 * Get Venue Categories
 */
export const getShipsByShipCodeVenueCategories = <ThrowOnError extends boolean = false>(options: Options<GetShipsByShipCodeVenueCategoriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetShipsByShipCodeVenueCategoriesResponse, unknown, ThrowOnError>({
        url: '/ships/{shipCode}/venueCategories',
        ...options
    });
};

/**
 * Get Venues
 */
export const getShipsByShipCodeVenueCategoriesByVenueCategoryCode = <ThrowOnError extends boolean = false>(options: Options<GetShipsByShipCodeVenueCategoriesByVenueCategoryCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetShipsByShipCodeVenueCategoriesByVenueCategoryCodeResponse, unknown, ThrowOnError>({
        url: '/ships/{shipCode}/venueCategories/{venueCategoryCode}',
        ...options
    });
};

/**
 * Get Trips
 */
export const getTrips = <ThrowOnError extends boolean = false>(options?: Options<GetTripsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTripsResponse, unknown, ThrowOnError>({
        url: '/trips',
        ...options
    });
};

/**
 * By Date
 */
export const getTripsByDateByDate = <ThrowOnError extends boolean = false>(options: Options<GetTripsByDateByDateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByDateByDateResponse, unknown, ThrowOnError>({
        url: '/trips/byDate/{date}',
        ...options
    });
};

/**
 * Invalidate Trips
 */
export const getTripsInvalidate = <ThrowOnError extends boolean = false>(options?: Options<GetTripsInvalidateData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTripsInvalidateResponse, unknown, ThrowOnError>({
        url: '/trips/invalidate',
        ...options
    });
};

/**
 * Invalidate Trip
 */
export const postTripsInvalidate = <ThrowOnError extends boolean = false>(options: Options<PostTripsInvalidateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'basic',
                type: 'http'
            }
        ],
        url: '/trips/invalidate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Cabin Information
 */
export const getTripsByTripCodeCabinTypesAndCategories = <ThrowOnError extends boolean = false>(options: Options<GetTripsByTripCodeCabinTypesAndCategoriesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByTripCodeCabinTypesAndCategoriesResponse, unknown, ThrowOnError>({
        url: '/trips/{tripCode}/cabinTypesAndCategories',
        ...options
    });
};

/**
 * Get Cabin Information
 */
export const getTripsByTripCodeCabinTypesAndCategoriesByCabinCategoryCode = <ThrowOnError extends boolean = false>(options: Options<GetTripsByTripCodeCabinTypesAndCategoriesByCabinCategoryCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByTripCodeCabinTypesAndCategoriesByCabinCategoryCodeResponse, unknown, ThrowOnError>({
        url: '/trips/{tripCode}/cabinTypesAndCategories/{cabinCategoryCode}',
        ...options
    });
};

/**
 * Get Cabins
 */
export const getTripsByTripCodeCabins = <ThrowOnError extends boolean = false>(options: Options<GetTripsByTripCodeCabinsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByTripCodeCabinsResponse, unknown, ThrowOnError>({
        url: '/trips/{tripCode}/cabins',
        ...options
    });
};

/**
 * Get Cabin
 */
export const getTripsByTripCodeCabinsByCabinNumber = <ThrowOnError extends boolean = false>(options: Options<GetTripsByTripCodeCabinsByCabinNumberData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByTripCodeCabinsByCabinNumberResponse, unknown, ThrowOnError>({
        url: '/trips/{tripCode}/cabins/{cabinNumber}',
        ...options
    });
};

/**
 * Get Checklist
 */
export const getTripsByTripCodeChecklist = <ThrowOnError extends boolean = false>(options: Options<GetTripsByTripCodeChecklistData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByTripCodeChecklistResponse, unknown, ThrowOnError>({
        url: '/trips/{tripCode}/checklist',
        ...options
    });
};

/**
 * Get Events
 */
export const getTripsByTripCodeEvents = <ThrowOnError extends boolean = false>(options: Options<GetTripsByTripCodeEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByTripCodeEventsResponse, unknown, ThrowOnError>({
        url: '/trips/{tripCode}/events',
        ...options
    });
};

/**
 * Get Theme Content
 */
export const getTripsByTripCodeThemeContent = <ThrowOnError extends boolean = false>(options: Options<GetTripsByTripCodeThemeContentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTripsByTripCodeThemeContentResponse, unknown, ThrowOnError>({
        url: '/trips/{tripCode}/themeContent',
        ...options
    });
};

/**
 * Get Venue By Venue Code
 */
export const getVenueByVenueCode = <ThrowOnError extends boolean = false>(options: Options<GetVenueByVenueCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVenueByVenueCodeResponse, unknown, ThrowOnError>({
        url: '/venue/{venueCode}',
        ...options
    });
};

/**
 * Get Venue Categories
 */
export const getVenueCategories = <ThrowOnError extends boolean = false>(options?: Options<GetVenueCategoriesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetVenueCategoriesResponse, unknown, ThrowOnError>({
        url: '/venueCategories',
        ...options
    });
};

/**
 * Get Venue Category
 */
export const getVenueCategoriesByVenueCategoryCode = <ThrowOnError extends boolean = false>(options: Options<GetVenueCategoriesByVenueCategoryCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetVenueCategoriesByVenueCategoryCodeResponse, unknown, ThrowOnError>({
        url: '/venueCategories/{venueCategoryCode}',
        ...options
    });
};